import React, { Component } from 'react';
import { connect } from 'react-redux'
import { GridLoader } from 'react-spinners';
import Backdrop from '../Backdrop/Backdrop';
import './style.css';

class Preloader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPreloading: false
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isPreloading !== prevProps.isPreloading) {
            this.setState({
                isPreloading: this.props.isPreloading
            });
        }
    }

    render() {
        return (
            <Backdrop show={this.state.isPreloading} className="d-flex align-items-center justify-content-center"> 
                <GridLoader
                    sizeunit={"px"}
                    size={20}
                    color={'#00BFFF'}
                    className={{ margin: "0 auto" }}
                    loading={this.state.isPreloading} />
            </Backdrop>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isPreloading: state.preloaderReducer.isPreloading
    }
}

const mapDispatchToProps = (dispatch) => ({
    //togglePreloader: (isPreloading) => { dispatch(viewAllCases(id)); },
});


export default connect(mapStateToProps, mapDispatchToProps)(Preloader)
